
import React, { useState, useRef } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { Alert, Button, Image, Input, Skeleton, Tag } from "antd";
import creationImg from '../../images/minified/placeholder_image.svg'
import kwsuggestion from "../../images/minified/keywordsugg-illustration.svg"
import Container from "../General/Container/Container";
import { setInputToDiscover, setLoadingResult, setLowscore, setMode, setNegativeTargets, setTargets } from "../../store/components/Minified.slice";
import { useDispatch, useSelector } from "react-redux";
import { addBuildTarget, removeAllBuildTarget, setStep } from "../../store/components/MarketExplorer.slice";
import InsightsServices from "../../services/Insights.services";
import useAutoFocus from "../../hooks/autofocus/useAutoFocus";
import { setCategoryDeepDiveData } from "../../store/components/Reports.slice";
import { useEffect } from "react";
import useKeywordSuggestion from "../../hooks/minified/useKeywordSuggestion";
import ModelsServices from "../../services/Models.services";
import { generateGUID } from "../../utils/MainHelper";
import WorkerServices from "../../services/Worker.services";
import TrackFeatureServices from "../../services/TrackFeature.services";
import { setCurrentSelectedMode } from "../../store/components/ReportBuilder.slice";

const MinifiedCreation = () => {
    const inputRef = useRef();
    const dispatch = useDispatch()
    const [discoveredTargets, setDiscoveredTargets] = useState([])

    const [discoverLoading, setDiscoverLoading] = useState(false)
    const [showError, setShowError] = useState(false)
    const { lowscore, inputToDiscover } = useSelector((state) => state.minified)

    const {
        kwsuggestionList,
        loadingKWSuggestion,
        selectedKWSuggestion,
        setSelectedKWSuggestion,
    } = useKeywordSuggestion()

    const callAutoFocus = useAutoFocus(inputRef);

    useEffect(() => {
        if (lowscore) {
            dispatch(setInputToDiscover(selectedKWSuggestion.join(", ")))
            callAutoFocus(inputRef.current)
        }
    }, [lowscore, selectedKWSuggestion])


    const onSubmit = async (targetsTemp) => {
        await dispatch(setCategoryDeepDiveData([]))
        await dispatch(setLoadingResult(true))
        await dispatch(setMode("result"))
        await dispatch(setTargets(targetsTemp))

        await dispatch(removeAllBuildTarget())
        await dispatch(setStep(3));
        await dispatch(setCurrentSelectedMode("marketcategory"))
        await dispatch(addBuildTarget({
            name: "Audience Name 1",
            key: generateGUID(),
            groups: [{
                text: 'Freeform',
                code: 'product_brand',
                packages: [
                    'consumer',
                    'pharma'
                ],
                bahavior: null,
                targets: targetsTemp.map((kw) => {
                    return {
                        name: kw,
                        children: [
                            {
                                name: kw
                            }
                        ]
                    }
                })
            }]
        }));
    }

    const getTargets = () => {
        const value = inputToDiscover.trim();
        if (value) {
            const { startMonitor, endMonitor } = TrackFeatureServices.getMonitor({ featureKey: "minifiedEntities" })
            setDiscoverLoading(true)
            let usedUrl = ""
            const callBackStart = (params, url) => {
                usedUrl = url
                startMonitor(params, { url: usedUrl })
            }
            InsightsServices.getTargetsFromText(value, callBackStart).then(async (resp) => {
                endMonitor(resp, { url: usedUrl })
                if (typeof resp === "string") {
                    setDiscoveredTargets([value])
                    onSubmit([value])
                    setShowError(false)
                    dispatch(setLowscore(false))
                } else {
                    ModelsServices.setNewEntitiesModel(value, resp)
                    const identified = await InsightsServices.identifyPositiveNegative(value) || {};
                    ModelsServices.setNewPositiveNegativeModel(value, identified?.data || {})
                    const negatives = identified?.data?.negative || [];
                    await WorkerServices.clearCache([]);
                    // const targetsTemp = (resp || []).filter((text) => (!negatives.includes(text)))
                    const targetsTemp = (resp || [])
                    // await dispatch(setNegativeTargets(negatives));
                    if (targetsTemp.length) {
                        setDiscoveredTargets(targetsTemp)
                        onSubmit(targetsTemp)
                        setShowError(false)
                        dispatch(setLowscore(false))
                    } else {
                        setShowError(true)
                        dispatch(setLowscore(true))
                    }
                }
                setDiscoverLoading(false)
            })
        }
    }

    const getKwClass = (kw) => {
        let classVal = "";
        if (selectedKWSuggestion.includes(kw)) {
            classVal = "oi-tag pointer"
        } else {
            classVal = "minified-creation-kwsuggestion-kw";
            if (selectedKWSuggestion.length >= 5) {
                classVal += " disabled"
            }
        }
        return classVal
    }
    return <Container className="minified-creation dcol align-center justify-center fullscreen">
        <Image preview={false} src={lowscore ? kwsuggestion : creationImg} />
        {lowscore
            ? <span className="minified-creation-subtitle">The query that you have entered has low audience turn out. Please try another query.</span>
            : <span className="minified-creation-title">What would you like to discover today?</span>
        }
        <Container className="minified-creation-search drow align-start">
            <Button onClick={() => {
                getTargets()
            }} type="text"><SearchOutlined /></Button>
            <Container className="minified-creation-search-tagcont drow align-center">
                <Input
                    disabled={discoverLoading}
                    ref={inputRef}
                    value={inputToDiscover}
                    placeholder="type something and hit enter"
                    onChange={(e) => {
                        dispatch(setInputToDiscover(e.target.value))
                    }}
                    onPressEnter={(e) => {
                        getTargets(e)
                    }}
                />
            </Container>
            {inputToDiscover
                ? <Button
                    loading={discoverLoading}
                    disabled={discoverLoading}
                    onClick={() => {
                        dispatch(setInputToDiscover(""))
                        setSelectedKWSuggestion([])
                    }} type="text">
                    {discoverLoading ? "" : "Clear"}
                </Button>
                : null
            }
        </Container>
        {lowscore ? <Container className="minified-creation-kwsuggestion dcol align-center">
            <span className="minified-creation-kwsuggestion-title">Try these suggested keywords:</span>
            <Container className="minified-creation-kwsuggestion-cont dwrap justify-center gap-1">
                {loadingKWSuggestion
                    ? "111111111111111111".split("").map((i, idx) => <Skeleton.Button key={idx} active />)
                    : kwsuggestionList.map((kw) => <Tag className={getKwClass(kw)}
                        onClick={(e) => {
                            if (e.target.className.includes("disabled")) return;
                            setSelectedKWSuggestion((prevList) => {
                                if (prevList.includes(kw)) return prevList.filter((prevKw) => prevKw !== kw)
                                return [...prevList, kw]
                            })
                        }}
                    >{kw}
                    </Tag>)
                }
            </Container>

        </Container> : null}
        {showError ? <Alert
            style={{ width: "200mm" }}
            message=""
            showIcon
            description="I'm sorry, there seems to be an error or misunderstanding. Could you please try rephrasing or rewriting your sentence? If the problem persists, you can try using advanced analysis."
            type="error"
            closable
            afterClose={() => {
                setShowError(false)
            }}
        /> : null}
    </Container>
}

export default MinifiedCreation